import UserService from '../../services/UserService';
import StatusEnum from "../../Enum/Status";

/**
 * Map status number to translation key
 * Status numbers are 1-based, so we subtract 1 to get the index
 */
const getStatusTranslationKey = (statusNumber) => {
  const keys = [
    'received',              // 1
    'beingProcessed',        // 2
    'inRetry',               // 3
    'delivered',             // 4
    'manuallyProcessed',     // 5
    'couldNotBeDelivered',   // 6
    'errorDuringProcessing', // 7
    'deliveredToIntermediary' // 8
  ];
  return keys[statusNumber - 1] || 'received';
};

/**
 * Check if a message's received date is older than 2 months
 */
const isMessageTooOld = (dateString) => {
  if (!dateString) return false;
  
  const messageDate = new Date(dateString);
  const twoMonthsAgo = new Date();
  twoMonthsAgo.setMonth(twoMonthsAgo.getMonth() - 2);
  
  return messageDate < twoMonthsAgo;
};

/**
 * Check if user has download permissions
 * Employees (Administrator, SD_Medewerker) can always download
 * Customers need Download or Download_compleet role
 */
const hasDownloadPermission = () => {
  if (UserService.hasRole(["Administrator", "SD_Medewerker"])) {
    return true;
  }
  return UserService.hasRole(["Download", "Download_compleet"]);
};

/**
 * Check if user has retry permissions
 * Employees (Administrator, SD_Medewerker) can always retry
 * Customers need Retry role
 */
const hasRetryPermission = () => {
  if (UserService.hasRole(["Administrator", "SD_Medewerker"])) {
    return true;
  }
  return UserService.hasRole(["Retry"]);
};

// const GetMessageStatusString = (status) => {
//     if (status === null || status === undefined) {
//         return null;
//     }

//     // Convert status to number (handle both string and number inputs)
//     const statusNum = typeof status === 'string' ? parseInt(status, 10) : status;
    
//     // Check if valid status (1-based, so index is statusNum - 1)
//     if (statusNum < 1 || statusNum > StatusEnum.length) {
//         return "Onbekend";
//     }

//     // Special case for status 5 when user is employee or admin
//     if (statusNum === 5 && UserService.hasRole(["SD_Medewerker", "Administrator"])) {
//         return "Handmatig verwerkt";
//     }

//     // Get status string from enum (statuses are 1-based, array is 0-based)
//     return StatusEnum[statusNum - 1] ?? "Onbekend";
// };

const GetMessageStatusColor = (status) => {
    let color = null;
    
    // Convert status to string for comparison
    const statusStr = typeof status === 'number' ? status.toString() : status;
    
    switch (statusStr)
    {
        case "1":
        case "2":
        case "8":
            color = "bg-blue-100 text-blue-800";
            break;
        case "3":
            color = "bg-yellow-100 text-yellow-800";
            break;
        case "4":
        case "5":
        case "Verwerkt":
            color = "bg-green-100 text-green-800";
            break;
        case "6":
        case "7":
            color = "bg-red-100 text-red-800";
            break;
    }

    return color ?? "bg-gray-100 text-gray-800";
};

export {
  getStatusTranslationKey,
  isMessageTooOld,
    hasDownloadPermission,
    hasRetryPermission,
    // GetMessageStatusString,
    GetMessageStatusColor
};